<template>
  <div>
    <v-card>
      <v-tabs v-model="tab">
        <v-tab :disabled="!currentSupplier" :value="'info'"
          >Информация по поставщику</v-tab
        >
        <v-tab
          v-if="
            currentSupplier &&
            cacheSupplier.priceReceiveMethod === 'api' &&
            currentSupplier.id > 0 &&
            currentSupplier.supplierApi &&
            currentSupplier.supplierApi.id > 0
          "
          :disabled="!currentSupplier"
          :value="'categories'"
          >Категории поставщика</v-tab
        >
        <v-tab
          v-for="item in supplierCategoryTabs"
          v-bind:key="item.id"
          :value="item.id"
          >{{ item.name }}
          <v-btn icon flat @click.stop="removeTab(item.id)"
            ><v-icon icon="$close"></v-icon></v-btn
        ></v-tab>
        <v-tab
          v-for="item in subcategoryTabs"
          v-bind:key="item.id"
          :value="item.id"
          >{{ item.name
          }}<v-btn icon flat @click.stop="removeSubcategoryTab(item.id)"
            ><v-icon icon="$close"></v-icon></v-btn
        ></v-tab>
      </v-tabs>
      <v-card-text>
        <v-progress-linear
          indeterminate
          color="primary"
          v-show="isSaving"
        ></v-progress-linear>
        <v-window v-model="tab">
          <v-window-item :value="'info'">
            <div v-if="currentSupplier">
              <v-row dense>
                <v-col cols="6" class="pa-6">
                  <EditSupplierInfo
                    @updateSupplier="updateAfterSave"
                    :currentSupplier="currentSupplier"
                  />
                </v-col>
                <v-col cols="6" class="pa-6">
                  <SupplierCurrenciesRates :currentSupplier="currentSupplier" />
                </v-col>
              </v-row>
            </div>
          </v-window-item>
          <v-window-item
            :value="'categories'"
            v-if="
              currentSupplier &&
              cacheSupplier.priceReceiveMethod === 'api' &&
              currentSupplier.id > 0 &&
              currentSupplier.supplierApi &&
              currentSupplier.supplierApi.id > 0
            "
          >
            <SupplierCategories :supplier="currentSupplier" />
          </v-window-item>
          <v-window-item
            v-for="item in supplierCategoryTabs"
            v-bind:key="item.id"
            :value="item.id"
          >
            <SupplierCategoryTab
              :category="item.item"
              :supplier="currentSupplier"
              @updateSubcategories="updateSubcategories"
            />
          </v-window-item>
          <v-window-item
            v-for="item in subcategoryTabs"
            v-bind:key="item.id"
            :value="item.id"
          >
            <SupplierSubcategoryTab
              :category="item.item"
              :supplier="currentSupplier"
            />
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SuppliersRepository = RepositoryFactory.get("suppliers");
const ExternalModuleRepository = RepositoryFactory.get("externalModules");
import SupplierCategories from "@/components/Supplier/SupplierCategories";
import SupplierCategoryTab from "@/components/Supplier/SupplierCategoryTab";
import SupplierSubcategoryTab from "@/components/Supplier/SupplierSubcategoryTab";
import EditSupplierInfo from "./EditSupplierInfo.vue";
import SupplierCurrenciesRates from "./SupplierCurrenciesRates.vue";

import { mapGetters, mapMutations } from "vuex";
export default {
  props: ["supplier"],
  components: {
    SupplierCategories,
    SupplierCategoryTab,
    SupplierSubcategoryTab,
    EditSupplierInfo,
    SupplierCurrenciesRates,
  },
  data() {
    return {
      modules: [],
      currentSupplier: null,
      cacheSupplier: null,
      isSaving: false,
      subcategoryTabs: [],
      loadingCurrencies: false,
    };
  },
  watch: {
    supplierActiveTab() {
      if (this.supplierActiveTab) {
        if (this.supplier) {
          this.currentSupplier = this.supplier;
          //this.getRates(this.currentSupplier.id);
          this.updateCacheSupplier();
        }
        this.setDefaultTab();
      }
    },
  },
  mounted() {
    this.getModules();
    if (this.supplier) {
      this.currentSupplier = this.supplier;
      //this.getRates(this.currentSupplier.id);
      this.updateCacheSupplier();
    }
    this.setDefaultTab();
  },
  methods: {
    ...mapMutations([
      "setCategoryActiveTab",
      "updateSupplierCategoryTabs",
      "updateSupplierSubcategoryTabs",
    ]),
    async update() {
      this.isSaving = true;
      let response = await SuppliersRepository.update(this.supplier);
      if (response.data.status === "success") {
        this.cacheSupplier = response.data.data;
      }
      this.isSaving = false;
    },
    async getModules() {
      const result = await ExternalModuleRepository.get();
      if (result) {
        this.modules = result.data;
      }
    },
    removeTab(id) {
      this.updateSupplierCategoryTabs(
        this.categoryTabs.filter((x) => x.id !== id)
      );
      this.setCategoryActiveTab("categories");
    },
    removeSubcategoryTab(id) {
      this.subcategoryTabs = this.subcategoryTabs.filter((x) => x.id !== id);
      this.setCategoryActiveTab("categories");
    },

    updateSubcategories(subcategoryTabs) {
      this.subcategoryTabs = subcategoryTabs;
    },
    setDefaultTab() {
      this.tab = "info";
    },
    updateCacheSupplier() {
      this.cacheSupplier = JSON.parse(JSON.stringify(this.currentSupplier));
    },
    updateAfterSave(supplier) {
      this.cacheSupplier = JSON.parse(JSON.stringify(supplier));
    },
  },
  computed: {
    ...mapGetters([
      "mainSupplier",
      "categoryTabs",
      "categoryActiveTab",
      "supplierActiveTab",
    ]),
    tab: {
      get() {
        return this.categoryActiveTab;
      },
      set(newValue) {
        this.setCategoryActiveTab(newValue);
      },
    },
    supplierCategoryTabs: {
      get() {
        if (this.currentSupplier) {
          return this.categoryTabs.filter(
            (x) => x.supplierId === this.currentSupplier.id
          );
        }
        return [];
      },
    },
  },
};
</script>
